<template>
  <div
    class="min-h-screen bg-white pt-12 pb-12"
    v-bind:style="{ backgroundImage: 'url(' + background + ')' }"
  >
  <MainHeader class="bg-white" />
  <AboutSubHeader />
  <AboutFooter />
  </div>
</template>

<script>
import MainHeader from "@/components/header/MainHeader.vue"
import AboutSubHeader from "@/components/content/title/subtitle/AboutSubTitle.vue"
import AboutFooter from "@/components/footer/AboutFooter.vue"

export default {
    name: "About",
    components: {
        MainHeader,
        AboutSubHeader,
        AboutFooter,
    }
}
</script>

<style>

</style>
